import { useEffect } from 'react'
import { useSearchStore } from '../stores/searchStore'

export default function TagPills() {
  const { popularTags, matchingTags, query, tagFilters, toggleTagFilter, fetchPopularTags } = useSearchStore()

  useEffect(() => {
    fetchPopularTags()
  }, [fetchPopularTags])

  // Use contextual matching_tags when search is active, otherwise popular tags
  const isSearchActive = query.trim().length > 0 && matchingTags.length > 0
  const tagsToShow = isSearchActive
    ? matchingTags.map((t) => ({ id: t.id, name: t.name, tag_type: t.tag_type, thread_count: t.count }))
    : popularTags

  if (tagsToShow.length === 0) return null

  // Separate personal (hashtag/manual) from AI (auto) tags
  const personalTags = tagsToShow.filter((t) => t.tag_type === 'hashtag' || t.tag_type === 'manual')
  const aiTags = tagsToShow.filter((t) => t.tag_type === 'auto')

  const hasBothGroups = personalTags.length > 0 && aiTags.length > 0

  return (
    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide items-center">
      {/* Personal tags on LEFT in gold */}
      {personalTags.slice(0, 10).map((tag) => (
        <button
          key={`personal-${tag.id}`}
          onClick={() => toggleTagFilter(tag.name)}
          className={`shrink-0 px-2.5 py-0.5 rounded-full text-xs transition-colors ${
            tagFilters.includes(tag.name)
              ? 'bg-amber-500/30 text-amber-300 border border-amber-400'
              : 'bg-amber-500/10 text-amber-400 border border-amber-500/30'
          }`}
        >
          {tag.name}
          <span className="ml-1 opacity-60">{tag.thread_count}</span>
        </button>
      ))}

      {/* Visual divider between groups */}
      {hasBothGroups && (
        <div className="shrink-0 w-px h-4 bg-border" />
      )}

      {/* AI tags on RIGHT in gray */}
      {aiTags.slice(0, 10).map((tag) => (
        <button
          key={`ai-${tag.id}`}
          onClick={() => toggleTagFilter(tag.name)}
          className={`shrink-0 px-2.5 py-0.5 rounded-full text-xs transition-colors ${
            tagFilters.includes(tag.name)
              ? 'bg-accent/20 text-accent border border-accent'
              : 'bg-surface text-text-secondary border border-border'
          }`}
        >
          {tag.name}
          <span className="ml-1 opacity-60">{tag.thread_count}</span>
        </button>
      ))}
    </div>
  )
}
